// packages/web-client/src/app/react/asset-list/filterSearchParams.ts

export interface PinFieldParam {
  name: string;
  operator?: string;
  value?: any;
}

/**
 * Resolves the operator and value for a custom field filter item
 * restored from the `pin_field` URL search parameter.
 *
 * Handles two storage formats:
 * - New: `{ name, operator, value }` — operator and value stored separately
 * - Legacy: `{ name, value }` — isEmpty/isNotEmpty were stored as the value string
 */
export function resolveRestoredPinField(pinField: PinFieldParam): {
  operator: string | undefined;
  value: any;
} {
  const isLegacyNullOp =
    pinField.value === "isEmpty" || pinField.value === "isNotEmpty";

  const operator =
    pinField.operator ?? (isLegacyNullOp ? pinField.value : undefined);

  const value =
    pinField.operator !== null && pinField.operator !== undefined
      ? pinField.value
      : isLegacyNullOp
      ? undefined
      : pinField.value;

  return { operator, value };
}
